import { string, object, Infer } from 'superstruct';

export const callbackDataSchema = object({
  otp: string(),
  nonce: string(),
});

export type CallbackData = Infer<typeof callbackDataSchema>;
